import { c as _c } from "react/compiler-runtime";
import { SVGProps, useState, CSSProperties } from 'react';
import { pick } from 'remeda';
import { G } from './G';
import { useDebouncedValue } from '@mantine/hooks';
import deepEqual from 'fast-deep-equal';
export type SvgProps = {
  sizeMode?: 'children' | 'parent';
  debug?: boolean;
  showWhenSettled?: boolean;
} & SVGProps<SVGElement> & {
  styles?: {
    svg?: CSSProperties;
    g?: CSSProperties;
  };
};

/** an SVG that is sized according to its children */
export const Svg = t0 => {
  const $ = _c(22);
  const {
    children,
    styles,
    style,
    sizeMode: t1,
    className,
    showWhenSettled: t2,
    debug
  } = t0;
  const sizeMode = t1 === undefined ? "parent" : t1;
  const showWhenSettled = t2 === undefined ? true : t2;
  const [childDim, setChildDim] = useState();
  const [visible, setVisible] = useState(sizeMode == "parent" || !showWhenSettled);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      leading: false
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const [debouncedWidth] = useDebouncedValue(childDim?.width, 150, t3);
  if (!visible && debouncedWidth) {
    setVisible(true);
  }
  const t4 = childDim?.height;
  const t5 = sizeMode == "parent" ? "100%" : debouncedWidth;
  const t6 = visible ? "visible" : "hidden";
  const t7 = styles?.svg;
  let t8;
  if ($[1] !== t4 || $[2] !== t5 || $[3] !== t6 || $[4] !== t7) {
    t8 = {
      height: t4,
      width: t5,
      visibility: t6,
      ...t7
    };
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== childDim) {
    t9 = t10 => {
      const {
        layout
      } = t10;
      if (layout == null) {
        return;
      }
      const newDim = pick(layout, ["width", "height"]);
      if (!deepEqual(newDim, childDim)) {
        setChildDim(newDim);
      }
    };
    $[6] = childDim;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const t10 = styles?.g;
  let t11;
  if ($[8] !== style || $[9] !== t10) {
    t11 = {
      ...style,
      ...t10
    };
    $[8] = style;
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== debug || $[12] !== t11 || $[13] !== t9) {
    t12 = {
      onLayout: t9,
      style: t11,
      debug
    };
    $[11] = debug;
    $[12] = t11;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== children || $[16] !== t12) {
    t13 = <G {...t12}>{children}</G>;
    $[15] = children;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== className || $[19] !== t13 || $[20] !== t8) {
    t14 = <svg style={t8} className={className}>{t13}</svg>;
    $[18] = className;
    $[19] = t13;
    $[20] = t8;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
};
export const GSpace = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props) {
    t0 = {
      x: 0,
      y: 0,
      width: 1,
      height: 1,
      ...props
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      visibility: "hidden"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <rect {...t0} style={t1} />;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};